import type { Components, Theme } from '@mui/material/styles';

export default function MuiFormControlLabel(theme: Theme): Components['MuiFormControlLabel'] {
  return {
    styleOverrides: {
      label: {
        fontFamily: theme.typography.fontFamily,
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '0px',
      },
    },
  };
}
